import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import AlertDialog from "../../components/alertDialog";
import MessagePanel from "../../components/messagePanel";
import { uzytkownicyActions } from "../../store/actions/uzytkownicy.actions";
import { IDRaksStore } from "../../store/store";
import {
  OrganizacjaWidok,
  Produkt,
  RolaUzytkownika,
} from "../../store/types/organizacje";
import { Uzytkownik } from "../../store/types/uzytkownicy";
import { UzytkownicyEdycjaStyle } from "../../styles/UzytkownicyEdycjaStyle";

interface UzytkownicyEdycjaProps {
  error: string;
  onZapros: Function;
  organizacja: OrganizacjaWidok;
  edytowany: string;
  onDaj: Function;
  onEdytuj: Function;
  onClearEditError: Function;
  closeDrawer?: Function;
  onSaveAction?: Function;
  beforeExit?: boolean;
  blockExit?: Function;
}

const UzytkownicyEdycja = (props: UzytkownicyEdycjaProps) => {
  const {
    closeDrawer,
    error,
    onZapros,
    onDaj,
    onEdytuj,
    onSaveAction,
    onClearEditError,
    beforeExit,
    blockExit,
    organizacja,
    edytowany,
  } = props;
  const [email, setEmail] = useState("");
  const [idZaproszenia, setIdZaproszenia] = useState("");
  const [rola, setRola] = useState(RolaUzytkownika.Uzytkownik);
  const [produkty, setProdukty] = useState(organizacja.Produkty);
  const [wiadomosc, setWiadomosc] = useState("");
  const [dirty, setDirty] = useState(false);
  const [potwierdzWyjscie, setPotwierdzWyjscie] = useState(false);

  useEffect(() => {
    if (beforeExit) {
      if (dirty) setPotwierdzWyjscie(true);
      else if (closeDrawer) closeDrawer();
    }
    // eslint-disable-next-line
  }, [beforeExit]);

  useEffect(() => {
    if (edytowany) {
      onDaj(organizacja.Id, edytowany).then((dto: Uzytkownik) => {
        setEmail(dto.Email);
        setIdZaproszenia(dto.IdZaproszenia);
        setRola(dto.Rola);
        setProdukty(dto.Produkty);
        setWiadomosc(dto.Wiadomosc);
      });
    }
    return () => {
      onClearEditError();
    };
    // eslint-disable-next-line
  }, []);

  const zapisz = () => {
    let promise = edytowany
      ? onEdytuj(organizacja.Id, idZaproszenia, rola, produkty)
      : onZapros(organizacja.Id, email, rola, produkty, wiadomosc);
    promise.then((res: boolean) => {
      if (res) {
        if (closeDrawer) closeDrawer();
        if (onSaveAction) onSaveAction();
      }
    });
  };

  const changeSwitch = (e: any) => {
    if (e.target.name === "Brunet")
      if (e.target.checked) setProdukty([...produkty, Produkt.Brunet]);
      else setProdukty(produkty.filter((x) => x !== Produkt.Brunet));
    else if (e.target.name === "Faktury")
      if (e.target.checked) setProdukty([...produkty, Produkt.Zioom]);
      else setProdukty(produkty.filter((x) => x !== Produkt.Zioom));
    else if (e.target.name === "KSeF")
      if (e.target.checked) setProdukty([...produkty, Produkt.Ksef]);
      else setProdukty(produkty.filter((x) => x !== Produkt.Ksef));
  };

  return (
    <>
      <UzytkownicyEdycjaStyle>
        <header>
          <h5>{edytowany ? "EDYCJA UŻYTKOWNIKA" : "NOWY UŻYTKOWNIK"}</h5>
          <Button
            name="btnZapisz"
            color="secondary"
            variant="contained"
            onClick={zapisz}
          >
            {edytowany ? "ZAPISZ" : "WYŚLIJ ZAPROSZENIE"}
          </Button>
        </header>
        {error ? (
          <MessagePanel mode="error" title="Błąd!" message={error} />
        ) : (
          <div />
        )}
        <form onChange={() => setDirty(true)}>
          <section>
            <h6>E-MAIL</h6>
            <TextField
              disabled={!!edytowany}
              label="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </section>
          <section>
            <h6>ROLA</h6>
            <FormControl variant="filled">
              <InputLabel id="select">Rola w systemie</InputLabel>
              <Select
                labelId="select"
                value={rola}
                onChange={(e: any) => setRola(e.target.value)}
              >
                <MenuItem value={RolaUzytkownika.Uzytkownik}>
                  Użytkownik
                </MenuItem>
                {organizacja.Rola === RolaUzytkownika.Wlasciciel && (
                  <MenuItem value={RolaUzytkownika.Administrator}>
                    Administrator
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </section>
          <section>
            <h6>DOSTĘP</h6>
            {organizacja.Produkty.includes(Produkt.Brunet) && (
              <div className="switch">
                <span className="body1">FINANSE I KSIĘGOWOŚĆ (BRUNET)</span>
                <Switch
                  name="Brunet"
                  checked={produkty.includes(Produkt.Brunet)}
                  onChange={changeSwitch}
                />
              </div>
            )}
            {organizacja.Produkty.includes(Produkt.Zioom) && (
              <div className="switch">
                <span className="body1">FAKTURY (Faktury.raks.pl)</span>
                <Switch
                  name="Faktury"
                  checked={produkty.includes(Produkt.Zioom)}
                  onChange={changeSwitch}
                />
              </div>
            )}
            {organizacja.Produkty.includes(Produkt.Ksef) && (
              <div className="switch">
                <span className="body1">KSeF (Ksef)</span>
                <Switch
                  name="KSeF"
                  checked={produkty.includes(Produkt.Ksef)}
                  onChange={changeSwitch}
                />
              </div>
            )}
          </section>
          {!edytowany && (
            <section>
              <h6>WIADOMOŚĆ</h6>
              <TextField
                label="Dodatkowa informacja dla Użytkownika"
                value={wiadomosc}
                onChange={(e) => setWiadomosc(e.target.value)}
              />
            </section>
          )}
        </form>
      </UzytkownicyEdycjaStyle>
      {potwierdzWyjscie && blockExit && closeDrawer && (
        <AlertDialog
          mode="YesNo"
          title="Potwierdzenie"
          content="Czy chcesz opuścić formularz bez zapisywania danych?"
          onAccept={() => {
            closeDrawer();
          }}
          onCancel={() => {
            setPotwierdzWyjscie(false);
            blockExit();
          }}
        ></AlertDialog>
      )}
    </>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    error: store.uzytkownicy.editError,
    organizacja: store.organizacje.wybrana,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onZapros: (
      idOrganizacji: string,
      email: string,
      rola: RolaUzytkownika,
      produkty: Produkt[],
      wiadomosc: string
    ) =>
      dispatch(
        uzytkownicyActions.zapros(
          idOrganizacji,
          email,
          rola,
          produkty,
          wiadomosc
        )
      ),
    onDaj: (idOrg: string, email: string) =>
      dispatch(uzytkownicyActions.daj(idOrg, email)),
    onEdytuj: (
      idOrg: string,
      idZapr: string,
      rola: RolaUzytkownika,
      produkty: Produkt[]
    ) => dispatch(uzytkownicyActions.edytuj(idOrg, idZapr, rola, produkty)),
    onClearEditError: () => dispatch(uzytkownicyActions.clearEditError()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UzytkownicyEdycja);
